import { Col, Row } from "@/app/components/lib/my-bootstrap";
import { useState } from "react";
import BtnQuantitySelector from "./btn-quantity-selector/BtnQuantitySelector";
import SvgCartDisabled from "./details-add-to-card-icons/SvgCartDisabled";
import SvgDetailsAddToCart from "./details-add-to-card-icons/SvgDetailsAddToCart";
import { useIsMobile } from "@/hooks/useIsMobile";
import {
  ICartItemExtraFields,
  IuseProductHasAttrsResult,
} from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import Price from "@/app/components/lib/Price";
import { goToCartAtom } from "../../../common/go-to-cart-pop-up/GoToCartPopUp";
import { useAtom } from "jotai";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { adaptFieldsToPost } from "@/app/components/common-form-builder/form-builder-helpers/form-functions";
import { Navbar } from "@/utils/bootstrap";
import { Link } from "@/app/components/lib/navigation/Link";
import { PagesPaths } from "@/utils/functions/pages-paths";
import NotFieldErrModal from "@/app/components/common-form-builder/form-builder-helpers/NotFieldErrModal";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useProductPopup from "@/hooks/useProductPopup";
import ProtectedContent from "@/app/components/common-builder/product/product-box/product-box-helpers/ProtectedContent";
import useSellingMode from "@/hooks/useSellingMode";
import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import SvgRegisterArrow from "./details-add-to-card-icons/SvgRegisterArrow";
import { fromProductPreviewTypeToCartItemType } from "../../../cart/cart-functions";
import { roundToFourDecimals } from "@/utils/functions/functions";
import ReminderForm from "@/app/components/common-builder/product/product-box/product-box-helpers/btn-expanding-add-to-card/ReminderForm";

interface Props {
  productState: IuseProductHasAttrsResult;
  form: UseFormReturn<FieldValues, any>;
  isPopupMobile: boolean;
  agreeTerms: boolean;
  popup?: "normal" | "configrable" | false;
}

const DetailsAddToCartBtn: React.FC<Props> = ({
  productState,
  form,
  isPopupMobile,
  agreeTerms,
  popup = false,
}) => {
  const {
    cartDisabled,
    handleAddToCart,
    handleQuantityChange,
    quantity,
    shouldConfig,
    variantNotExist,
    requiredAddonsNotChosen,
    outOfStock,
    addedToCart,
    subTotalPrice,
    plusDisabled,
    notFieldErr,
    setNotFieldErr,
    currentProd,
    selectedUnitId,
    disableRegistrationEvent,
    notAllBundleItemsChildrenSelected,
  } = productState;
  const isEvent = currentProd.preview_type === ProductPreviewTypes.event;
  const { min_quantity_in_cart, units } = currentProd;
  const selectedUnit = units.find((unit) => unit.id === selectedUnitId);
  const { enableAddToCart } = useSellingMode();
  const getCompany = useGetCompanyQuery();
  const t = useTranslation();
  const [reminderOpen, setReminderOpen] = useState(false);
  const addToCartTxt =
    getCompany?.data?.result?.theme?.components?.product?.add_to_cart_btn_title;
  const mobile = useIsMobile();
  const [, setOpenGoToCardModal] = useAtom(goToCartAtom);
  const { handleClosePopup } = useProductPopup();
  const noClickEvent = addedToCart || cartDisabled || !agreeTerms;

  const DontshowRemidnMeBtn =
    shouldConfig ||
    variantNotExist ||
    requiredAddonsNotChosen ||
    disableRegistrationEvent ||
    notAllBundleItemsChildrenSelected ||
    !agreeTerms;
  const showRemidnMeBtn =
    outOfStock &&
    getCompany.data?.result?.theme?.components?.product
      ?.allow_user_request_stock_availability_reminder &&
    !DontshowRemidnMeBtn;

  const addToCartBtn = (
    <ProtectedContent showChildren={enableAddToCart}>
      <button
        // type="submit"
        onClick={
          noClickEvent
            ? undefined
            : form.handleSubmit((data, e) => {
                e?.stopPropagation();
                const other_inputs = adaptFieldsToPost(data);
                handleAddToCart(
                  {
                    type: fromProductPreviewTypeToCartItemType(
                      currentProd.preview_type,
                    ),
                  } as unknown as ICartItemExtraFields,
                  other_inputs,
                );
                setOpenGoToCardModal(true);
              })
        }
        className={`btn-product-add-to-cart ${
          cartDisabled || !agreeTerms
            ? "disabled"
            : addedToCart
            ? "added-to-cart"
            : ""
        }`}
      >
        <>
          {cartDisabled || !agreeTerms ? (
            <div className="cart-disabled-text w-100">
              <SvgCartDisabled />
              <p>
                {shouldConfig
                  ? t.choose_variant
                  : variantNotExist
                  ? t.this_variant_not_available
                  : outOfStock
                  ? t.out_of_stock
                  : requiredAddonsNotChosen
                  ? t.choose_required_addons
                  : !agreeTerms
                  ? t.you_should_agree_to_terms_conditions
                  : disableRegistrationEvent
                  ? t.registration_disabled_for_now
                  : notAllBundleItemsChildrenSelected
                  ? t.choose_variant_for_all_bundle_items
                  : t.sell_disabled}
              </p>
            </div>
          ) : !addedToCart ? (
            <div
              className={`not-added-to-cart-text w-100 ${
                isEvent
                  ? "d-flex flex-row-reverse justify-content-center align-items-center"
                  : ""
              }`}
            >
              {isEvent ? <SvgRegisterArrow /> : <SvgDetailsAddToCart />}
              {isEvent
                ? t.register_now
                : addToCartTxt
                ? addToCartTxt
                : t.add_to_cart}
            </div>
          ) : (
            <>
              <Link
                prefetch={false}
                href={PagesPaths.cart}
                onClick={() => handleClosePopup()}
              >
                <Row className="m-0 align-items-center added-to-cart-text">
                  <Col className="p-0">
                    <Row className="m-0 go-to-cart">{`${t.go_to_cart} (${quantity})`}</Row>
                    <Row className="m-0 flex flex-nowrap align-items-center justify=content-center">
                      {`${t.subtotal}:`}
                      <Price
                        price={{
                          value: roundToFourDecimals(subTotalPrice * quantity),
                          className: "price",
                        }}
                        roundPrice
                      />
                    </Row>
                  </Col>
                </Row>
              </Link>
              <BtnQuantitySelector
                minQuantity={
                  selectedUnit?.min_quantity_in_cart &&
                  selectedUnit?.min_quantity_in_cart > 0
                    ? selectedUnit?.min_quantity_in_cart
                    : min_quantity_in_cart ?? 1
                }
                quantity={quantity}
                setQuantity={handleQuantityChange}
                plusDisabled={plusDisabled}
                addedToCart={addedToCart}
                disableChangeQuantity={isEvent}
              />
            </>
          )}
        </>
      </button>
    </ProtectedContent>
  );
  const RemidnMeBtn = (
    <ProtectedContent showChildren={enableAddToCart}>
      <button
        onClick={() => setReminderOpen(true)}
        className={"btn-product-add-to-cart   justify-content-center"}
      >
        <div className="d-flex gap-2 align-items-center  justify-content-center">
          <svg
            width={14}
            height={14}
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.63856 0.00871651C4.59682 0.199086 1.49988 3.67162 1.49988 7.69036V11.3241L0.174688 13.9902C0.172357 13.995 0.170078 13.9999 0.167852 14.0048C-0.365276 15.1386 0.497737 16.4999 1.75086 16.4999H5.99988C5.99988 18.1479 7.35195 19.4999 8.99988 19.4999C10.6478 19.4999 11.9999 18.1479 11.9999 16.4999H16.2479C17.5011 16.4999 18.3652 15.1388 17.8319 14.0048C17.8297 13.9999 17.8274 13.995 17.8251 13.9902L16.4999 11.3241V7.49993C16.4999 3.24683 12.9315 -0.19339 8.63856 0.00871651ZM8.70887 1.50676C12.1689 1.34387 14.9999 4.08103 14.9999 7.49993V11.4999C14.9998 11.6158 15.0265 11.7301 15.078 11.8339L16.4745 14.6445C16.5643 14.8369 16.4604 14.9999 16.2479 14.9999H1.75086C1.5384 14.9999 1.43534 14.8372 1.52527 14.6445V14.6435L2.92176 11.8339C2.97325 11.7301 2.99999 11.6158 2.99988 11.4999V7.69036C2.99988 4.44009 5.48961 1.65839 8.70887 1.50676ZM7.49988 16.4999H10.4999C10.4999 17.337 9.83695 17.9999 8.99988 17.9999C8.16282 17.9999 7.49988 17.337 7.49988 16.4999Z"
              fill="white"
            />
          </svg>
          {t.remind_me}
        </div>
      </button>
    </ProtectedContent>
  );

  return (
    <>
      <ReminderForm
        product={{
          name: currentProd.name,
          description: currentProd.description,
          image: currentProd?.thumbnail_url,
          rate: currentProd?.rate,
          id: currentProd.id,
        }}
        isOpen={reminderOpen}
        setIsOpen={setReminderOpen}
      />

      {notFieldErr.length > 0 && (
        <NotFieldErrModal errors={notFieldErr} setErrors={setNotFieldErr} />
      )}

      {mobile ? (
        <Navbar
          fixed="bottom"
          className={`mobile-place-order-btn ${isPopupMobile ? "vw-100" : ""}`}
        >
          {showRemidnMeBtn ? RemidnMeBtn : addToCartBtn}
        </Navbar>
      ) : (
        <div className={popup === false ? "col-7 col" : undefined}>
          {showRemidnMeBtn ? RemidnMeBtn : addToCartBtn}
        </div>
      )}
    </>
  );
};

export default DetailsAddToCartBtn;
